import type { RouteObject } from "src/router";

import { lazyNamed } from "src/utils/lazy-named";

const EventLibrary = lazyNamed(
  () => import("../event-studio/components/event-library"),
  "EventLibrary",
);

const EventDetail = lazyNamed(
  () => import("../event-studio/components/event-detail"),
  "EventDetail",
);

export const routes: Array<RouteObject> = [
  {
    index: true,
    spacesAccess: "hidden-from-limited-view",
    element: <EventLibrary />,
  },
  {
    path: ":event_type_and_name",
    spacesAccess: "hidden-from-limited-view",
    element: <EventDetail />,
  },
];
